import Image from 'next/image';
import cn from 'classnames';
import { AnchorArrow } from 'react-scale/components';

import styles from './logo-farm.module.css';

const cx = require('classnames');

// eslint-disable-next-line no-return-assign
const LogoFarm = ({ theme, logos, limit, columns, flex, bottomText }) => (
  <div className="relative grid text-white">
    <ul
      className={cx(
        'items-center justify-center gap-8 lg:gap-16',
        { grid: !flex },
        { 'grid justify-between lg:flex': flex },
        `lg:grid-cols-${columns.lg}`,
        `md:grid-cols-${columns.md}`,
        `sm:grid-cols-${columns.sm}`,
        `grid-cols-${columns.xs}`
      )}
    >
      {logos?.slice(0, limit).map(
        (item, index) =>
          item?.logo?.value?.data && (
            <CustomerLogo
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              logo={item?.logo?.value?.data}
              theme={theme}
              columns={columns}
            />
          )
      )}
    </ul>
    {bottomText?.text && (
      <p className="mt-12 text-base text-center text-silver">
        <span className="mr-2">{bottomText?.text}</span>
        {bottomText.link?.href && (
          <span className="inline">
            <AnchorArrow href={bottomText.link.href} text={bottomText.link.label} />
          </span>
        )}
      </p>
    )}
  </div>
);

const CustomerLogo = ({ logo, theme, columns }) => (
  <li key={logo?.alt} className="flex items-center justify-center h-full align-middle">
    <Image
      width={logo?.width}
      height={logo?.height}
      className={cn(
        icon[theme],
        logo?.square ? 'w-full' : 'w-[80%] object-fill',
        { 'aspect-[18/2]': columns.lg <= 3 && columns.md <= 3 && !logo?.square },
        { 'aspect-[11/2]': columns.lg <= 5 && columns.md <= 5 && !logo?.square },
        { 'aspect-[7/2]': columns.lg >= 6 && columns.md >= 6 && !logo?.square },
        { 'aspect-[8/2]': columns.lg <= 5 && columns.md <= 5 && logo?.square },
        { 'aspect-[5/2]': columns.lg >= 6 && columns.md >= 6 && logo?.square }
      )}
      src={logo?.image}
      alt={logo?.alt ?? 'logo'}
      quality={100}
      unoptimized
    />
  </li>
);

const icon = {
  dark: styles.dark,
  light: styles.light
};

LogoFarm.defaultProps = {
  theme: 'dark',
  columns: { xs: 4, sm: 4, md: 7, lg: 7 },
  limit: 32
};

export default LogoFarm;
